import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";

import Typography from "@mui/material/Typography";
import { PreviewImage } from "./PreviewImage";

const CARD_PADDING = "8px";
const ITEM_GAP = "6px";
const HALF_ITEM_GAP = "3px";

const FULL_PREVIEW_HEIGHT = {
	sm: "250px",
	xs: "125px",
};

const STACK_PREVIEW_HEIGHT = {
	sm: `calc((250px - ${ITEM_GAP}) / 2)`,
	xs: `calc((125px - ${ITEM_GAP}) / 2)`,
};

const borderBox = {
	boxSizing: "border-box",
	"& *, & *::before, & *::after": {
		boxSizing: "border-box",
	},
};

const Item = styled(Paper)(({ theme }) => ({
	boxSizing: "border-box",
	backgroundColor: "rgba(255,255,255,0.025)",
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: "center",
	color: theme.palette.text.secondary,
	width: "100%",
	height: "100%",
	display: "grid",
	gridAutoFlow: "column",
	justifyContent: "center",
	alignItems: "center",
}));

const styles = {
	container_full: {
		...borderBox,
		position: "relative",
		display: "grid",
		width: "100%",
		p: CARD_PADDING,
	},

	container_row_item_left: {
		...borderBox,
		position: "relative",
		display: "grid",
		flexGrow: 1,
		width: "70%",
		pr: HALF_ITEM_GAP,
		pl: CARD_PADDING,
		pt: CARD_PADDING,
		pb: CARD_PADDING,
	},

	container_row_item_right: {
		...borderBox,
		position: "relative",
		display: "grid",
		width: "50%",
		height: "50%",
		pl: HALF_ITEM_GAP,
		pr: CARD_PADDING,
		pt: CARD_PADDING,
		pb: CARD_PADDING,
	},

	stack_item_top: {
		...borderBox,
		position: "relative",
		display: "grid",
		width: "100%",
		mb: ITEM_GAP,
	},

	stack_item_bottom: {
		...borderBox,
		position: "relative",
		display: "grid",
		width: "100%",
	},

	preview_large: {
		...borderBox,
		position: "relative",
		borderRadius: "5px",
		height: FULL_PREVIEW_HEIGHT,
		width: "100%",
		cursor: "pointer",
		overflow: "hidden",
	},

	preview_stack_top: {
		...borderBox,
		position: "relative",
		borderRadius: "5px",
		height: STACK_PREVIEW_HEIGHT,
		width: "100%",
		cursor: "pointer",
		overflow: "hidden",
	},

	preview_stack_bottom: {
		...borderBox,
		position: "relative",
		borderRadius: "5px",
		height: STACK_PREVIEW_HEIGHT,
		width: "100%",
		cursor: "pointer",
		overflow: "hidden",
	},

	more_container: {
		...borderBox,
		position: "relative",
		display: "grid",
		placeItems: "center",
		height: STACK_PREVIEW_HEIGHT,
		width: "100%",
		userSelect: "none",
		cursor: "pointer",
	},
};

const getPreviewAssetId = (asset: any) => {
	if (!asset || typeof asset !== "object") {
		return "";
	}

	return asset?.preview_asset_id || asset?.id || asset?.fio_asset_id || asset?.upload_id || asset?.uploadId || asset?.coconut_upload_id || asset?.image_upload_id || "";
};

const VersionCardPreviewItem = (props: any) => {
	const assetId = getPreviewAssetId(props?.asset);
	const strictAssetId = props?.strict_asset_id === true;

	const previewImageKey = `${props.type || "preview"}:${assetId || "empty"}:${strictAssetId ? "strict" : "fallback"}`;

	const commonPreviewProps = {
		key: previewImageKey,
		status: props.status,
		version: props.version,
		assetId,
		autoplay: false,
		is_visible: true,
		img_type: "thumb_scrub",
		strict_asset_id: strictAssetId,
	};

	const handleMoreClick = (e: any) => {
		e.stopPropagation();

		if (typeof props.onclick === "function") {
			props.onclick();
		}
	};

	switch (props.type) {
		case "full":
			return (
				<Box sx={styles.container_full}>
					<PreviewImage {...commonPreviewProps} sx={styles.preview_large} />
				</Box>
			);

		case "half_left":
			return (
				<Box sx={styles.container_row_item_left}>
					<PreviewImage {...commonPreviewProps} sx={styles.preview_large} />
				</Box>
			);

		case "half_right":
			return (
				<Box sx={styles.container_row_item_right}>
					<PreviewImage {...commonPreviewProps} sx={styles.preview_large} />
				</Box>
			);

		case "third_right_top":
			return (
				<Box sx={styles.stack_item_top}>
					<PreviewImage {...commonPreviewProps} sx={styles.preview_stack_top} />
				</Box>
			);

		case "third_right_bottom":
			return props.filecount > 3 ? (
				<Box onClick={handleMoreClick} sx={styles.more_container}>
					<Item color="text.primary">
						<Typography variant="h6" color="text.secondary">
							+
						</Typography>

						<Typography variant="h6" color="text.primary">
							{props.filecount - 2}
						</Typography>
					</Item>
				</Box>
			) : (
				<Box sx={styles.stack_item_bottom}>
					<PreviewImage {...commonPreviewProps} sx={styles.preview_stack_bottom} />
				</Box>
			);

		default:
			return null;
	}
};

export default VersionCardPreviewItem;
